import { useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { performSessionEndLogout } from '../../auth/idleLogoutEvents';
import { useAutoLogout } from '../../hooks/useAutoLogout';
import InactivityWarningDialog from '../InactivityWarning/InactivityWarningDialog';

/**
 * Enforces client-side idle logout (TC-AUT-001–003).
 */
export default function AutoLogoutManager({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, logoutDueToSessionEnd } = useAuth();
  const handleIdleLogout = useCallback(() => {
    performSessionEndLogout(logoutDueToSessionEnd, 'idle');
  }, [logoutDueToSessionEnd]);
  const { warningOpen, stayLoggedIn, secondsUntilLogout } = useAutoLogout({
    enabled: isAuthenticated,
    onLogout: handleIdleLogout,
  });

  return (
    <>
      {children}
      <InactivityWarningDialog
        open={warningOpen}
        secondsUntilLogout={secondsUntilLogout}
        onStayLoggedIn={stayLoggedIn}
      />
    </>
  );
}
